import axios from 'axios'
import globalStore from '@/stores/global.svelte'

class GroupsStore {
  state = $state({
    groups: []
  })

  // allGroup = $derived(globalStore.currentAccount?.all_group || {})
  allGroup = $derived.by(() => {
    return globalStore.currentAccount?.all_group || {}
  })

  groupsByName = $derived.by(() => {
    return this.state.groups.sort((a, b) => {
      let nameA = a.name.toUpperCase() // ignore upper and lowercase
      let nameB = b.name.toUpperCase() // ignore upper and lowercase
      if (nameA < nameB) {
        return -1
      }
      if (nameA > nameB) {
        return 1
      }

      return 0
    })
  })

  async fetch() {
    return axios.get('/groups.json')
      .then((response) => {
        this.state.groups = response.data
        globalStore.setErrors([])
      })
      .catch((error) => {
        globalStore.setErrors(error)
      })
  }

  createNewGroup(name) {
    return new Promise((resolve, reject) => {
      axios.post('/groups.json', {
        group: { name }
      })
        .then((response) => {
          globalStore.setErrors([])
          resolve(response.data)
        })
        .catch((error) => {
          globalStore.setErrors(error.response.data.errors)
          reject(error)
        })
    })
  }

}

const groupsStore = new GroupsStore()
export default groupsStore
